// Cross-origin isolation in Safari. WebKit (Safari, and every browser on iPhone and iPad) has no
// COEP `credentialless`, which is what Re:Vault's pages send, so none of them is isolated there.
// Only a top-level /linux gets `require-corp` from the server for those browsers
// (src/server/lib/isolation.js webkitCoep); a book title that needs isolation cannot get it.

// Same test as the server's: WebKit, and not a Chromium browser (those say Chrome/ too).
export function noCredentialless(ua) {
	const s = String(ua == null ? (globalThis.navigator && navigator.userAgent) || "" : ua);
	return /AppleWebKit\//.test(s) && !/(?:Chrome|Chromium)\//.test(s);
}
// Whether a same-origin title that needs isolation would get it in a top-level tab of its own.
export function canIsolate(g = globalThis) {
	return g.crossOriginIsolated === true || !noCredentialless(g.navigator && g.navigator.userAgent);
}
export const NEEDS_OTHER_BROWSER = "This title needs Chrome, Edge or Firefox. It may not run in Safari.";
